import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import BookingListFilterService, {
  ICategorisedBookingList,
} from 'external-services/booking-list-filter-service/index';
import { FILTER_TYPE } from 'booking-card-list/BookingFiltersCompact/types';
import { DiaryRootState } from 'app/appRoot/rootReducer';
import { IConflict } from 'external-services/bookings-conflicts-service/bookingConflicts.types'
import { IAffectedBooking, IServiceListView } from 'shared-types'

interface IConflictState {
  timeConflicts: IAffectedBooking[];
  tableConflicts: IAffectedBooking[];
  overlapConflicts: IConflict[];
}

export interface IFilteredBookingsState {
  bookingsByType: ICategorisedBookingList;
  selectedType: string;
  filterServiceView?: IServiceListView;// for Booking Card List filter
  freeTextSearch: string;
  page: number;
  conflicts?: IConflictState;
}
const initialState: IFilteredBookingsState = {
  bookingsByType: {
    booked: [],
    waitlist: [],
    standbyList: [],
    seated: [],
    cancelled: [],
    finished: [],
  },
  conflicts: {
    timeConflicts: [],
    tableConflicts: [],
    overlapConflicts: [],
  },
  freeTextSearch: '',
  selectedType: FILTER_TYPE.BOOKED,
  page: 1,
  filterServiceView: null,
};

export const loadFilteredBookings = createAsyncThunk(
  'booking/loadFilteredBookings',
  async (_, { getState }): Promise<ICategorisedBookingList> => {
    try {
      const {
        venueReducer: { standByList },
        scheduleReducer: { selectedSchedule },
        bookingReducer: { couchReducedBookings: bookings },
      } = getState() as DiaryRootState;
      return bookings?.length
        ? await BookingListFilterService.getCategorisedBookingList(
            bookings,
            standByList,
            selectedSchedule,
            true
          )
        : BookingListFilterService.getEmptyCategorisedBookingList();
    } catch (e) {
      console.error('serviceQtyList', e);
      return {};
    }
  }
);

const slice = createSlice({
  name: 'booking/filter', // used in action types
  initialState,
  reducers: {
    __setTestData: (
      state: IFilteredBookingsState,
      action: PayloadAction<IFilteredBookingsState>
    ) => {
      state.bookingsByType = action.payload.bookingsByType;
      state.selectedType = action.payload.selectedType;
    },

    setSelectedType: (state: IFilteredBookingsState, action: PayloadAction<string>) => {
      state.selectedType = action.payload;
    },
    setFilterServiceView: (state: IFilteredBookingsState, action: PayloadAction<IServiceListView>) => {
      state.filterServiceView = action.payload;
    },
    setFreeSearch: (state: IFilteredBookingsState, action: PayloadAction<string>) => {
      state.freeTextSearch = action.payload;
    },

    // Pagination
    incrementPage: (state: IFilteredBookingsState) => {
      state.page += 1;
    },
    resetPage: (state: IFilteredBookingsState) => {
      state.page = 1;
    },
    setConflicts: (state: IFilteredBookingsState, action: PayloadAction<IConflictState>) => {
      state.conflicts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadFilteredBookings.fulfilled, (state: IFilteredBookingsState, action) => {
      state.bookingsByType = action.payload;
    });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = slice;
// Extract and export each action creator by name
export const { setSelectedType, incrementPage, setFreeSearch, setConflicts } = actions;
export const filterBookingActions = actions;
// Export the reducer, either as a default or named export
export default reducer;
